import { render, staticRenderFns } from "./contactModule.vue?vue&type=template&id=24c48b34&scoped=true"
import script from "./contactModule.vue?vue&type=script&lang=js"
export * from "./contactModule.vue?vue&type=script&lang=js"
import style0 from "./contactModule.vue?vue&type=style&index=0&id=24c48b34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c48b34",
  null
  
)

export default component.exports